import ViewsManagment from './ViewManagment';
export default ViewsManagment;
